export default function TriageAgentAvatar(): JSX.Element {
	return (
		<svg
			aria-hidden="true"
			focusable="false"
			preserveAspectRatio="none"
			overflow="visible"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g>
				<path
					d="M10.8 0.692821C11.5426 0.264102 12.4574 0.264102 13.2 0.69282L21.1923 5.30718C21.9349 5.7359 22.3923 6.5282 22.3923 7.38564V16.6144C22.3923 17.4718 21.9349 18.2641 21.1923 18.6928L13.2 23.3072C12.4574 23.7359 11.5426 23.7359 10.8 23.3072L2.8077 18.6928C2.06513 18.2641 1.6077 17.4718 1.6077 16.6144V7.38564C1.6077 6.5282 2.06513 5.7359 2.8077 5.30718L10.8 0.692821Z"
					fill="#1868DB"
				/>
				<g>
					<path
						d="M18.0138 16.6618C18.1259 16.7739 18.1889 16.9259 18.1889 17.0845C18.1889 17.243 18.1259 17.3951 18.0138 17.5072L16.0209 19.5L15.1756 18.6546L16.1478 17.6823H14.3123C13.8323 17.6823 13.4054 17.4932 13.0538 17.1233L12.3892 16.4635L13.1598 15.5161L13.9401 16.3103C14.0609 16.4202 14.1924 16.4866 14.3123 16.4866H16.1478L15.1756 15.5144L16.0209 14.669L18.0138 16.6618Z"
						fill="white"
					/>
					<path
						d="M18.1872 12.0076C18.1872 11.849 18.1242 11.697 18.0121 11.5849L16.0193 9.59208L15.1739 10.4375L16.1462 11.4097H13.0206V12.6054H16.1462L15.1739 13.5777L16.0193 14.4231L18.0121 12.4303C18.1242 12.3182 18.1872 12.1661 18.1872 12.0076Z"
						fill="white"
					/>
					<path
						d="M18.0139 6.49281C18.2473 6.72629 18.2473 7.10473 18.0139 7.3382L16.021 9.33102L15.1756 8.48563L16.1479 7.51335H13.8803C13.7604 7.51341 13.6469 7.56745 13.5713 7.66048L10.0067 12.0108C9.70401 12.3833 9.24976 12.6 8.76975 12.6H5.81147V11.4044H8.76975C8.88965 11.4043 9.00315 11.3503 9.07879 11.2572L12.6434 6.90695C12.9461 6.5344 13.4003 6.31772 13.8803 6.31766H16.1479L15.1756 5.34539L16.021 4.5L18.0139 6.49281Z"
						fill="white"
					/>
					<path
						d="M13.6746 13.964C13.6746 14.2103 13.5207 14.4305 13.2893 14.5149L12.4287 14.8284C12.3204 14.8679 12.2347 14.9536 12.1952 15.0619L11.8817 15.9225C11.7973 16.1538 11.5772 16.3078 11.3308 16.3078C11.0846 16.3078 10.8644 16.1539 10.78 15.9225L10.4664 15.0619C10.4269 14.9536 10.3413 14.8679 10.233 14.8284L9.37237 14.5149C9.16978 14.441 9.02652 14.263 8.99395 14.0548L8.98708 13.964L8.99395 13.8732C9.02653 13.6649 9.16988 13.4871 9.37237 13.4132L10.233 13.0996C10.3413 13.0601 10.4269 12.9745 10.4664 12.8662L10.78 12.0056L10.8181 11.9224C10.92 11.7384 11.1149 11.6206 11.3301 11.6203L11.4209 11.6272C11.5996 11.6549 11.7559 11.7642 11.8435 11.9224L11.8817 12.0056L12.1952 12.8662C12.2347 12.9745 12.3204 13.0601 12.4287 13.0996L13.2893 13.4132C13.5208 13.4976 13.6746 13.7179 13.6746 13.964Z"
						fill="white"
					/>
				</g>
			</g>
		</svg>
	);
}
